import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { GET_CREDIT_SUBMISSION_DECLINE_REASONS } from '../api';
import { getSubmissionDeclineReasonsOptions } from '../lib';
import { CreditSubmissionDeclindeReasonsResponse, DeclineReasonOption } from '../types';

interface UseDeclineReasonsParams {
  accountId: string | undefined;
  creditSubmissionDeclineReasonId?: string | null;
  skip?: boolean;
}

export const useDeclineReasons = ({ accountId, creditSubmissionDeclineReasonId, skip }: UseDeclineReasonsParams) => {
  const { data, refetch, loading } = useQuery<CreditSubmissionDeclindeReasonsResponse>(
    GET_CREDIT_SUBMISSION_DECLINE_REASONS,
    {
      variables: { accountId },
      skip: !accountId || skip,
    }
  );

  const options = useMemo(() => getSubmissionDeclineReasonsOptions(data?.creditSubmissionDeclineReasons ?? []), [data]);

  const selectedOption = useMemo<DeclineReasonOption | null>(
    () =>
      creditSubmissionDeclineReasonId ? (options.find(o => o.value === creditSubmissionDeclineReasonId) ?? null) : null,
    [options, creditSubmissionDeclineReasonId]
  );

  return {
    options,
    selectedOption,
    declineReasons: data?.creditSubmissionDeclineReasons ?? [],
    refetch,
    loading,
  };
};
